import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center text-center px-4 bg-background-950">
      <h1 className="font-heading text-7xl md:text-9xl font-black text-background-800 select-none">
        404
      </h1>
      <div className="relative z-10 -mt-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50 mt-6">
          页面不存在或已下线
        </h2>
        <p className="mt-2 text-sm text-foreground-500 break-all">
          {location.pathname}
        </p>
        <p className="mt-4 text-sm md:text-base text-foreground-400 max-w-md">
          你访问的页面可能已被移除或链接有误，可以返回首页继续浏览影视内容。
        </p>
        <div className="mt-7 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 px-6 py-3 rounded-md bg-primary-600 hover:bg-primary-500 text-background-50 text-sm font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category"
            className="inline-flex items-center gap-1.5 px-6 py-3 rounded-md bg-background-900 border border-background-700 hover:border-accent-500 text-foreground-100 text-sm font-medium cursor-pointer whitespace-nowrap transition-colors"
          >
            <i className="ri-film-line"></i>
            浏览分类
          </Link>
        </div>
      </div>
    </div>
  );
}